import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {finishLoading} from '../../../../modules/loading';
import {changeField, cancelConnect, saveDB, saveSQLite, updateDB, updateSQLite} from '../../../../modules/admin/database';
import styles from './styles/database-test.module.css';

import TypeBox from './common/TypeBox';
import ButtonRadius50 from '../../../design-system/button/ButtonRadius50';
import ButtonText from '../../../design-system/button/ButtonText';
import {PropagateLoader} from 'react-spinners';
import {ReactComponent as Failure} from '../../../../assets/db-connect/failure.svg';
import {ReactComponent as Success} from '../../../../assets/db-connect/success.svg';
import {ReactComponent as Reload} from '../../../../assets/db-connect/reload.svg';

export default function DatabaseTest({ connectionInfo, setCurrentStepName, handleReload, toggleAddModal }) {
    const dispatch = useDispatch();

    const { connectNewResponse, connectNewError, saveResponse, saveError, updateResponse, updateError, cancelResponse, cancelError, connectNewDBLoading, connectNewSQLiteLoading, saveDBLoading, saveSQLiteLoading, updateDBLoading, updateSQLiteLoading, cancelLoading } = useSelector(({ database, loading }) => ({
        connectNewResponse: database.connectNewResponse,
        connectNewError: database.connectNewError,
        saveResponse: database.saveResponse,
        saveError: database.saveError,
        updateResponse: database.updateResponse,
        updateError: database.updateError,
        cancelResponse: database.cancelResponse,
        cancelError: database.cancelError,
        connectNewDBLoading: loading['database/CONNECT_NEW_DB'],
        connectNewSQLiteLoading: loading['database/CONNECT_NEW_SQLITE'],
        saveDBLoading: loading['database/SAVE_DB'],
        saveSQLiteLoading: loading['database/SAVE_SQLITE'],
        updateDBLoading: loading['database/UPDATE_DB'],
        updateSQLiteLoading: loading['database/UPDATE_SQLITE'],
        cancelLoading: loading['database/CANCEL_CONNECT']
    }));

    const initializeResponse = () => {
        dispatch(changeField({ name: 'connectNewResponse', value: null }));
        dispatch(changeField({ name: 'connectNewError', value: null }));
        dispatch(changeField({ name: 'saveResponse', value: null }));
        dispatch(changeField({ name: 'saveError', value: null }));
        dispatch(changeField({ name: 'updateResponse', value: null }));
        dispatch(changeField({ name: 'updateError', value: null }));
        dispatch(changeField({ name: 'cancelResponse', value: null }));
        dispatch(changeField({ name: 'cancelError', value: null }));
    };

    const clickConnectCancelBtn = () => {
        dispatch(cancelConnect(connectionInfo));
    };

    const clickCancelBtn = () => {
        setCurrentStepName('info');
        initializeResponse();
    };

    const clickSaveBtn = () => {
        const { id, dbType, dbName, dbFile, aliasName, dbPassword } = connectionInfo;
    
        if (dbType === 'SQLITE') {
            const formData = new FormData();
        
        
            // 필요한 데이터 추가

            // 필요한 데이터 추가
            formData.append('dbType', dbType);
            formData.append('dbName', dbName);
            formData.append('dbFile', dbFile);
            formData.append('aliasName', aliasName);
    
            if (id) { // SQLITE 이면서 수정
                formData.append('id', id);
                dispatch(updateSQLite(formData));
            } else { // SQLITE 이면서 신규 연결(추가)
                dispatch(saveSQLite(formData));
            }
        } else { // SQLITE가 아닌 경우
            const { id, ...rest } = connectionInfo; // id와 id가 아닌 경우 분리

            const payload = {
                ...rest,
                password: dbPassword
            };
    
            if (id) {
                dispatch(updateDB({
                    ...connectionInfo,
                    password: dbPassword
                }));
            } else {
                dispatch(saveDB(payload));
            }
        }
    };    

    const getSaveBtnStyle = () => {
        if (saveDBLoading || saveSQLiteLoading || updateDBLoading || updateSQLiteLoading) return { text: 'loading', status: 'active' };
        if (!saveDBLoading && !saveSQLiteLoading && saveError) return { text: '재시도', status: 'error' };
        if (!updateDBLoading && !updateSQLiteLoading && updateError) return { text: '재시도', status: 'error' };

        return { text: '저장', status: 'active' };
    };

    const getCancelConnectComponent = () => {
        if (cancelLoading) {
            return (
                <ButtonText
                    height='H18'
                    status='active'
                    text='취소중'
                    handleClick={null}
                />
            );
        }

        if (!cancelLoading && cancelError) {
            return (
                <div className={styles.boxReload}>
                    <p>연결 취소 중 <span>오류</span> 발생</p>
                    <div className={styles.reload}>재시도 <Reload /></div>
                </div>
            );
        }

        return (
            <ButtonText
                height='H18'
                status='active'
                text='연결 취소'
                handleClick={clickConnectCancelBtn}
            />
        );
    };

    useEffect(() => {
        if (!cancelLoading && cancelResponse) {
            setCurrentStepName('info');
            dispatch(finishLoading('database/CONNECT_NEW_DB'));     // 연결 요청 로딩 상태 변경
            dispatch(finishLoading('database/CONNECT_NEW_SQLITE')); // 연결 요청 로딩 상태 변경
        }
    }, [cancelLoading, cancelResponse]);

    useEffect(() => {
        if ((!saveDBLoading && !saveSQLiteLoading && saveResponse) || (!updateDBLoading && !updateSQLiteLoading && updateResponse)) {
            toggleAddModal();
            handleReload();
        }
    }, [saveResponse, updateResponse, saveDBLoading, saveSQLiteLoading, updateDBLoading, updateSQLiteLoading]);

    // 컴포넌트 언마운트 시 응답들 초기화
    useEffect(() => {
        return () => {
            initializeResponse();
        };
    }, []);

    return (
        <div className={styles.wrapper}>
            {(connectNewDBLoading || connectNewSQLiteLoading) &&
                <>
                    <div className={styles.containerLoading}>
                        <TypeBox
                            step='test'
                            dbType='DARVIS'
                        />
                        <PropagateLoader color='#A79CFF' />
                        <TypeBox
                            step='test'
                            dbType={connectionInfo.dbType}
                        />
                    </div>
                    {getCancelConnectComponent()}
                </>
            }

            {!(connectNewDBLoading || connectNewSQLiteLoading) && connectNewResponse &&
                <>
                    <div className={styles.containerResult}>
                        <div className={styles.boxIcon}>
                            <Success />
                        </div>
                        <p className={styles.result}>연결 성공!</p>
                    </div>
                    <div className={styles.boxBtn}>
                        <ButtonText
                            height='H18'
                            text='취소'
                            handleClick={clickCancelBtn}
                        />
                        <ButtonRadius50
                            width='100px'
                            height='H40'
                            status={getSaveBtnStyle().status}
                            text={getSaveBtnStyle().text}
                            handleClick={clickSaveBtn}
                        />
                    </div>
                </>
            }

            {!(connectNewDBLoading || connectNewSQLiteLoading) && connectNewError &&
                <>
                    <div className={styles.containerResult}>
                        <div className={styles.boxIcon} data-type='error'>
                            <Failure />
                        </div>
                        <p className={styles.result} data-type='error'>연결 실패</p>
                        <div className={styles.message}>{connectNewError.message || '실패'}</div>
                    </div>
                    <ButtonRadius50
                        width='100px'
                        height='H40'
                        status='inactive'
                        text='확인'
                        handleClick={clickCancelBtn}
                    />
                </>
            }
        </div>
    );
}
